// extracted by mini-css-extract-plugin
module.exports = {"container":"endpoints-delay_container__2L-Yj","element":"endpoints-delay_element__2o0D9","selected":"endpoints-delay_selected__1-tRM"};